import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css';
import { Slide, Fade } from 'react-awesome-reveal';
import Headroom from "react-headroom";

const nearestIndex = (
  currentPosition,
  sectionPositionArray,
  startIndex,
  endIndex
) => {
  if(!sectionPositionArray[startIndex].ref.current && sectionPositionArray[endIndex].ref.current){
    return startIndex;
  }
  if (startIndex === endIndex) return startIndex;
  else if (startIndex === endIndex - 1) {
    if (
      Math.abs(
        sectionPositionArray[startIndex].ref.current.offsetTop -
        currentPosition
      ) <
      Math.abs(
        sectionPositionArray[endIndex].ref.current.offsetTop -
        currentPosition
      )
    )
      return startIndex;
    else return endIndex;
  } else {
    var nextNearest = ~~((startIndex + endIndex) / 2);
    var a = Math.abs(
      sectionPositionArray[nextNearest].ref.current.offsetTop -
      currentPosition
    );
    var b = Math.abs(
      sectionPositionArray[nextNearest + 1].ref.current.offsetTop -
      currentPosition
    );
    if (a < b) {
      return nearestIndex(
        currentPosition,
        sectionPositionArray,
        startIndex,
        nextNearest
      );
    } else {
      return nearestIndex(
        currentPosition,
        sectionPositionArray,
        nextNearest,
        endIndex
      );
    }
  }
};

const Navbar = ({ darkBackground, sections }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [shrink, setShrink] = useState(false);
  const navbarRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleClickOutside = (event) => {
    if (navbarRef.current && !navbarRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setShrink(true);
    } else {
      setShrink(false);
    }
    var index = nearestIndex(
      window.scrollY,
      sections,
      0,
      sections.length - 1
    );
    setActiveIndex(index);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const logoSrc = darkBackground ? 'MAIN-red-white-1line.png' : 'CAPS logo b_w.png';

  return (
    <Headroom>
      <div className={`Navbar ${shrink ? "shrink" : ""}`} ref={navbarRef}>
        <div className={`logo ${shrink ? "shrink" : ""}`}>
          <a href='#home'> <img src={logoSrc} alt="Center for Advanced Pain Studies Logo" /></a>
        </div>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <div className={`nav-items ${isMenuOpen ? 'open' : ''} ${shrink ? "shrink" : ""}`}>
            <Fade direction='right' cascade duration={100} triggerOnce>
              <div className={`nav-item ${activeIndex === 0 ? 'active' : ''}`}><a href='#home'>Home</a></div>
              <div className={`nav-item ${activeIndex === 1 ? 'active' : ''}`}><a href='#our-data'>Data</a></div>
              <div className={`nav-item ${activeIndex === 2 ? 'active' : ''}`}><a href='#contact'>Find Us</a></div>
            </Fade>
          </div>
          <button className={`hamburger ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
            <span className="bar top"></span>
            <span className="bar center"></span>
            <span className="bar bottom"></span>
          </button>
        </div>
      </div>
    </Headroom>
  );
};

export default Navbar;
